import React, { useState } from 'react';
import PokemonSelector from './PokemonSelector'


const Pokemon = () => {
    const [type, setType] = useState("");
    const handleType = type => setType(type);
    return (
        <div className="selector">

            <PokemonSelector type={type} handleType={handleType} />

        </div>


    )



}


export default Pokemon;